import { render, staticRenderFns } from "./WhatsNewModal.vue?vue&type=template&id=99c1420a"
import script from "./WhatsNewModal.vue?vue&type=script&lang=js"
export * from "./WhatsNewModal.vue?vue&type=script&lang=js"
import style0 from "./WhatsNewModal.vue?vue&type=style&index=0&id=99c1420a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports